import * as types from "../redux/types";
import backend from "../api/api";
import { message } from "antd";

export const verifyPin = (pin, token) => async (dispatch) => {
  try {
    const response = await backend.post(
      "api/contact/employee-auth/verify-pin/",
      { pin },
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      }
    );
    if (response.data.success) {
      return { success: true };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    return {
      success: false,
      message: (error.response && error.response.data && error.response.data.message) || "Verification failed",
    };
  }
};

export const signIn = (logInformValues) => async (dispatch) => {
  try {
    const response = await backend.post("api/contact/login/", {
      ...logInformValues,
    });
    console.log(response);
    dispatch({ type: types.SIGN_IN, payload: response.data });
    return true;
  } catch (error) {
    message.error("Unable to log in with provided credentials.");
    dispatch({ type: types.AUTH_FAILED });
    return false;
  }
};

export const activelink = (Menu) => async (dispatch) => {
  dispatch({ type: types.Active, Menu: Menu });
};

export const protectedAction = (Protected) => async (dispatch) => {
  dispatch({ type: types.Protected, Protected: Protected });
};

export const signOut = () => (dispatch) => {
  dispatch({ type: types.SIGN_OUT });
  window.location.href = "/login";
};
